import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateQuotes } from '@/modules/Quote/gql/quote.gql'
import { Quote } from '@/modules/Quote/interfaces/quote'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchQuote extends Vue {
  candidatesQuote: Quote[] = []

  get candidatesQuoteOptions () {
    return this.candidatesQuote.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async getCandidateQuotes (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateQuotes,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: 0,
            limit: 100
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesQuote = result.data.getQuotes.quotes
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
